import { render, staticRenderFns } from "./ShowTable.vue?vue&type=template&id=5d641f79&scoped=true&"
import script from "./ShowTable.vue?vue&type=script&lang=js&"
export * from "./ShowTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d641f79",
  null
  
)

export default component.exports